import { gql } from '@apollo/client'

export const DELETE_ATTENDEE = gql`
    mutation DeleteEventAttendees($input: deleteEventAttendeesInput!) {
        deleteEventAttendees(input: $input) {
            entity {
                guid
            }
        }
    }
`
